<template>
  <div class="w-100">

    <div class="exam__content" :class="{'exam__content--space-for-sidebar':optionValue===QUESTION_SETTINGS_ALL}">

      <QuestionPaginationComponent v-if="showPagination" :questions="priorities"/>

      <div v-if="currentQuestion.id && optionValue===QUESTION_SETTINGS_BY_ONE" class="exam__question-section">

        <div class="exam__question-section-title">
          {{ currentQuestion.priority }}.
        </div>

        <div v-if="currentQuestion.section" class="exam__label-descr">
          {{ currentQuestion.section }}
        </div>

        <div class="exam__question-text">
          <MathJaxComponent v-if="currentQuestion.type === 'fill_in'" :formula="currentQuestion.question"/>
          <span v-if="currentQuestion.type !== 'fill_in'" v-html="currentQuestion.question"></span>
        </div>

        <!-- question image -->
        <img v-if="currentQuestion.photoUrl" class="exam__question-img mb-4" :src="currentQuestion.photoUrl" alt="Фигура вопроса">
        <!-- question-image-end -->

        <ul v-if="currentQuestion.type!=='fill_in'" class="exam__answers-list">

          <li v-if="currentQuestion.type==='single'" v-for="item in currentQuestion.answers" class="exam__answer-item">
            <label class="radio radio--inline" @change="saveAnswer(currentQuestion.id,currentQuestion.priority)">
              <input class="radio__input" type="radio" v-model="answer" :value="item.id" name="radioBtnSample1">
              <span class="radio__indicator  radio__indicator--inline"></span>
              <span class="radio__label" v-html="item.answer"></span>
            </label>
          </li>

          <li v-if="currentQuestion.type==='multiple'" v-for="item in currentQuestion.answers" class="exam__answer-item">
            <label class="checkbox" @change="saveAnswer(currentQuestion.id,currentQuestion.priority)">
              <input class="checkbox__input" type="checkbox" v-model="multipleAnswers" name="answer" :value="item.id">
              <span class="checkbox__indicator  checkbox__indicator--lg  checkbox__indicator--inline"></span>
              <span class="checkbox__label" v-html="item.answer"></span>
            </label>
          </li>

        </ul>

        <div v-if="currentQuestion.type==='fill_in' && currentQuestion.answers.length > 0" class="exam__answers-list">

          <div v-if="currentQuestion.answers.length===1" v-html="currentQuestion.answers.answer"></div>

          <div v-else v-for="item in currentQuestion.answers">
            <span v-html="item.answer"></span>
          </div>

        </div>

        <div v-if="currentQuestion.type==='fill_in'" class="form  mb-4">

          <label class="exam__label-descr  form__label  form__label--block" :for="'answerField-'+currentQuestion.priority">
            {{ currentQuestion.description }}
          </label>

          <input class="field" autocomplete="off" type="text" :id="'answerField-'+currentQuestion.priority" v-model.trim="answer">
          <a class="btn btn--sm btn--main ml-2" v-on:click="saveAnswer(currentQuestion.id,currentQuestion.priority)" href="javascript:void(0)">{{ getTranslation('save') }}</a>

        </div>

        <a @click="nextQuestion" class="btn  btn--with-icon  mt-2  mb-0  pr-0  pl-0" href="javascript:void(0)"
           :class="{'pagination-2__btn--disabled': (currentQuestionId > questions.length || currentQuestionId === questions.length)}">
          {{ getTranslation('nextQuestion') }}

          <svg class="btn__icon  pl-2  m-0" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.428 13.5h17.696l-7.559 7.94a1.554 1.554 0 0 0 0 2.12 1.38 1.38 0 0 0 2.02 0l9.997-10.5a1.554 1.554 0 0 0 0-2.12L13.585.44a1.39 1.39 0 0 0-1.01-.44c-.365 0-.73.147-1.01.44a1.554 1.554 0 0 0 0 2.12l7.56 7.94H1.427C.64 10.5 0 11.172 0 12c0 .829.64 1.5 1.428 1.5z"/>
          </svg>

        </a>

      </div>

      <div class="question-list--all mt-3" v-if="optionValue===QUESTION_SETTINGS_ALL">

        <div v-for="question in questions" v-bind:key="question.id" :id="'question-'+question.priority" class="exam__question-section mb-3">

          <div class="exam__question-section-title">
            {{ question.priority }}.
          </div>

          <div v-if="question.section" class="exam__label-descr">
            {{ question.section }}
          </div>

          <div class="exam__question-text" @click="()=>{$router.push({query:{question:question.priority}}).catch(()=>{})}" style="cursor:pointer;">

            <MathJaxComponent v-if="question.type === 'fill_in'" :formula="question.question"/>

            <span v-if="question.type !== 'fill_in'" v-html="question.question"></span>

          </div>

          <!-- question image -->
          <img v-if="question.photoUrl" class="exam__question-img mb-4" :src="question.photoUrl" alt="Фигура вопроса">
          <!-- question-image-end -->

          <ul v-if="question.type!=='fill_in'" class="exam__answers-list">

            <!--    single-->
            <li v-if="question.type==='single'" v-for="item in question.answers" class="exam__answer-item">
              <label class="radio radio--inline" @change="saveAnswer(question.id,question.priority,answerList[question.priority],question.type)">
                <input class="radio__input" type="radio" v-model="answerList[question.priority]" :value="item.id" :name="'question-'+question.priority">
                <span class="radio__indicator  radio__indicator--inline"></span>
                <span class="radio__label" v-html="item.answer"></span>
              </label>
            </li>
            <!--    single end -->

            <!--    multiple-->
            <li v-if="question.type==='multiple'" v-for="item in question.answers" class="exam__answer-item">
              <label class="checkbox" @change="saveAnswer(question.id,question.priority,answerList[question.priority],question.type)">
                <input class="checkbox__input" type="checkbox" v-model="answerList[question.priority]" :name="'question-'+question.priority" :value="item.id">
                <span class="checkbox__indicator  checkbox__indicator--lg  checkbox__indicator--inline"></span>
                <span class="checkbox__label" v-html="item.answer"></span>
              </label>
            </li>
            <!--   multiple end -->

          </ul>

          <!--    fill_in  with answers-->
          <div v-if="question.type==='fill_in' && question.answers.length > 0" class="exam__answers-list">

            <div v-if="question.answers.length===1" v-html="question.answers.answer"></div>

            <div v-else v-for="item in question.answers">
              <span v-html="item.answer"></span>
            </div>

          </div>
          <!--    fill_in  with answers end -->

          <!--    fill_in  -->
          <div v-if="question.type==='fill_in'" class="form  mb-4">

            <label class="exam__label-descr  form__label  form__label--block" :for="'answerField2'+question.priority">
              {{ question.description }}
            </label>

            <input class="field" type="text" autocomplete="off" :id="'answerField2'+question.priority" v-model.trim="answerList[question.priority]">

            <a class="btn btn--sm btn--main ml-2" v-on:click="saveAnswer(question.id,question.priority,answerList[question.priority],question.type)" href="javascript:void(0)">{{ getTranslation('save') }}</a>

          </div>
          <!--    fill_in  end -->

        </div>

      </div>

    </div>

    <!-- right side navigation -->
    <div class="exam__pager--wrapper">

      <div class="exam__pager" :class="{'exam__pager-expanded': showNav}">

        <div class="pager">

          <a class="pager__link" href="javascript:void(0)">
            <div class="pager__item">
              <div class="pager__item-toggler" @click="toggleNav"></div>
              <h6 class="pager__label  mb-0">{{ getTranslation('questionsList') }}</h6>
            </div>
          </a>

          <svg :class="{'pager-btn--disabled': currentQuestionId <= 1}"
               @click="goPrevQuestion" style="transform: rotate(90deg);margin: 5px 3px;position: relative; left: 4px; height: 25px;width: 25px;cursor: pointer" class="btn__icon">
            <use xlink:href="#icon__arrow-2-left"></use>
          </svg>

          <vuescroll ref="vs" v-on:handle-resize="handleResize" v-on:window-resize="handleResize" :ops="ops">

            <div v-bind:style="{maxHeight: windowHeight+'px !important'}">

              <a v-for="item in questions" class="pager__link" href="javascript:void(0)" @click="goToQuestion(item.priority)">
                <div class="pager__item" v-bind:class="{'pager__item--current': currentQuestionId === item.priority,'pager__item--answered': isAnswered(item.priority)}">
                  <div class="pager__num">{{ item.priority }}</div>
                  <div class="pager__label" v-html="item.question"></div>
                </div>
              </a>

            </div>

          </vuescroll>

          <div :class="{'pager-btn--disabled': currentQuestionId === questions.length || currentQuestionId > questions.length}" style="position: fixed;margin-top: 5px">
            <svg @click="nextQuestion" style="transform: rotate(90deg);margin: 5px 3px; position: relative; left: 4px; height: 25px;width: 25px;cursor: pointer" class="btn__icon">
              <use xlink:href="#icon__arrow-2-right"></use>
            </svg>
          </div>

        </div>
        <!-- /.pager -->
      </div>
    </div>
    <!-- right side navigation end-->

  </div>
</template>

<script>
import Header from "../layouts/Header";
import QuestionPaginationComponent from "./components/QuestionPaginationComponent";
import {required} from "vuelidate/lib/validators";
import testMixin from "./mixins/test";
import vuescroll from 'vuescroll';
import MathJaxComponent from "@/components/MathJaxComponent";

export default {
  name: "Index",
  components: {MathJaxComponent, QuestionPaginationComponent, Header, vuescroll},
  mixins: [testMixin],
  data() {
    return {
      questions: [],
      priorities: [],
      showPagination: false,
      currentQuestion: {id: '', priority: ''},
      answerForm: {
        priority: '',
        questionId: '',
        answer: [],
      },
      multipleAnswers: [],
      answerList: {},
      answer: '',
      nextQ: true,
      answers: [],
      showNav: false,
      ops: {
        rail: {
          opacity: '1',
          background: '',
          border: '1px transparent #2e71e5',
          size: '10px'
        },
        scrollButton: {
          enable: false,
          background: '#2e71e5',
          opacity: 1,
          step: 180,
          mousedownStep: 30
        },
        bar: {
          background: '#80b0ff',
          keepShow: true,
          size: '8px',
          minSize: 0.2
        },

        scrollPanel: {
          easing: 'easeInQuad',
          speed: 800,
          scrollingX: false
        },
        vuescroll: {
          wheelScrollDuration: 0,
          wheelDirectionReverse: false
        }
      },
      windowHeight: 0
    }
  },
  beforeCreate() {
    this.$store.dispatch('candidate/enableTimer');
  },
  created() {

    this.windowHeight = window.innerHeight * 0.75;

    this.fetchTests().then(arr => {

      this.priorities = arr;

      this.showPagination = true;

      this.getCurrentQuestion();

      this.setHeadings({
        breadcrumbs: [
          {
            label: this.currentQuestion.testType
          }
        ]
      });
    });
  },
  mounted() {
    this.$root.$on('nextTest', () => {


      if (this.questions.length > 0) {

        if (this.questions[0].testTypeId !== this.$store.getters['candidate/getCurrentTesting'].testTypeId)

          this.fetchTests().then(arr => {

            this.$store.dispatch('candidate/enableTimer');

            this.priorities = arr;

            this.showPagination = true;

            this.getCurrentQuestion(this.currentQuestionId);

            this.setHeadings({
              breadcrumbs: [
                {
                  label: this.currentQuestion.testType
                }
              ]
            });
          });

      } else {

        this.fetchTests().then(arr => {

          this.$store.dispatch('candidate/enableTimer');

          this.priorities = arr;

          this.showPagination = true;

          this.getCurrentQuestion(this.currentQuestionId);

          this.setHeadings({
            breadcrumbs: [
              {
                label: this.currentQuestion.testType
              }
            ]
          });

        });
      }

    })
  },
  computed: {
    currentQuestionId() {
      return parseInt(this.$route.query.question) || 1;
    },

    questionType() {
      return this.currentQuestion.type;
    },

    questionId() {
      return this.currentQuestion.id;
    },

    optionValue() {

      if (this.$store.getters['candidate/getCurrentTesting'] && this.$store.getters['candidate/getCurrentTesting'].questionSettings)
        return this.$store.getters['candidate/getCurrentTesting'].questionSettings.optionValue
      else
        return false;
    }
  },
  watch: {
    'questionId'(val) {
      if (this.optionValue && this.optionValue === this.QUESTION_SETTINGS_BY_ONE)
        this.getVoteInfo(val || 1);
    },

    'currentQuestionId'(val) {

      this.$nextTick(() => {
        this.$refs['vs'].scrollIntoView('.pager__item--current', 300);
      });

      if (val)
        this.getCurrentQuestion(parseInt(val));
      else
        this.getCurrentQuestion();
    },
  },
  methods: {
    handleResize() {
      this.windowHeight = window.innerHeight * 0.75; //75% max height
    },

    toggleNav() {
      this.showNav = !this.showNav;
    },

    goToQuestion(priority) {
      this.$router.push({query: {question: priority}}).catch(() => {
      });
    },

    goPrevQuestion() {
      if (this.currentQuestionId > 1)
        this.$router.push({query: {question: this.currentQuestionId - 1}}).catch(() => {
        });
    },

    isAnswered(priority) {
      let answers = this.$store.getters['candidate/getAnswers'];
      if (answers.length > 0) {
        for (let item of answers) {
          if (item.priority === priority)
            return true;
        }

        return false;
      }
      return false;
    },

    nextQuestion() {
      let maxId = this.questions.length;

      if ((this.currentQuestionId + 1) > maxId || maxId === this.currentQuestionId) {

        this.nextQ = false;

      } else {

        this.$router.push({query: {question: (this.currentQuestionId + 1)}}).then(() => {

        }).catch(() => {

        });

        this.nextQ = true;
      }
    },

    getVoteInfo(questionId) {
      this.axios.get(this.$config.urls.candidateTesting.voteInfo.url, {params: {id: questionId, token: this.getAccessToken(), lang: this.testingLocale || 'ru_RU'}})
          .then(response => {

            let data = response.data.data;

            if (data.test)
              this.$store.dispatch('candidate/setCurrentNPA', data.test);


            if (data.testing) {
              if (data.answer.length > 0)

                this.storeAnswer({
                  questionId: response.data.data.id,
                  priority: this.currentQuestionId,
                  answer: response.data.data.answer
                });

              switch (this.questionType) {
                case 'fill_in':
                case 'single':
                  this.answer = data.answer[0];
                  break;
                case 'multiple':
                  this.multipleAnswers = data.answer;
                  break;
              }

              if (data.modal) {

                this.$store.dispatch('candidate/setCurrentTesting', data.candidateTest);

                let timerInterval;

                Swal.fire({
                  title: this.getTranslation(data.modal),
                  timer: 20000,
                  html: '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>',
                  footer: data.text ? this.getTranslation(data.text) : this.getTranslation('clickOK'),
                  showCancelButton: false,
                  showConfirmButton: true,
                  timerProgressBar: true,
                  onBeforeOpen: () => {
                    timerInterval = setInterval(() => {
                    }, 1000)
                  },
                  onClose: () => {
                    clearInterval(timerInterval)
                  }
                }).then((result) => {

                  this.$router.replace({query: {question: '1'}});

                  this.$root.$emit('nextTest');
                })
              }


            } else {
              let timerInterval;

              Swal.fire({
                title: this.getTranslation(data.message),
                timer: 20000,
                html: '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>',
                footer: data.text ? this.getTranslation(data.text) : this.getTranslation('clickOK'),
                showCancelButton: false,
                showConfirmButton: true,
                timerProgressBar: true,
                onBeforeOpen: () => {
                  timerInterval = setInterval(() => {
                  }, 1000)
                },
                onClose: () => {
                  clearInterval(timerInterval)
                }
              }).then((result) => {

                this.resetTesting().then(() => {

                  if (data.testingId) {
                    this.$router.push({name: 'candidate.results', params: {id: data.testingId}}).catch(() => {
                    });

                  } else {

                    this.$router.push({name: 'auth.success'}).catch(() => {
                    });

                  }
                });
              })
            }

          }).catch(() => {
        this.snotifyError('errorAskAdmin', null, 5000);
      })
    },

    fetchTests() {
      return this.axios.get(this.$config.urls.candidateTesting.tests.url, {
        params: {
          accessToken: this.getAccessToken()
        }
      }).then(response => {
        this.questions = response.data.data;

        let answered = [];

        for (let item of response.data.data) {

          if (this.optionValue && this.optionValue === this.QUESTION_SETTINGS_ALL) {

            if (item.candidateAnswer && item.candidateAnswer.length > 0)

              if (item.type === 'multiple')
                this.answerList[item.priority] = item.candidateAnswer;
              else
                this.answerList[item.priority] = item.candidateAnswer[0];

            else
              this.answerList[item.priority] = [];
          }

          if (item.candidateAnswer && item.candidateAnswer.length > 0) {
            answered.push({
              questionId: item.id,
              answer: item.candidateAnswer,
              priority: item.priority
            });
          }
        }

        this.$store.dispatch('candidate/setAnswereds', answered);

        return response.data.data.map(item => {
          return item.priority;
        });
      }).catch(() => {

        this.snotifyError('errorAskAdmin', null, 5000);

        this.resetTesting().then(() => {
          this.$router.replace({name: 'auth.success'}).catch(() => {
          });
        });
      });
    },

    async saveAnswer(questionId, priority, answer = null, type = null) {

      this.resetAnswerForm();

      if (this.currentQuestion && this.currentQuestion.test)
        await this.$store.dispatch('candidate/setCurrentNPA', this.currentQuestion.test);

      this.answerForm.questionId = questionId;
      this.answerForm.priority = priority;

      if (this.optionValue && this.optionValue === this.QUESTION_SETTINGS_BY_ONE) {
        switch (this.questionType) {
          case 'fill_in':
          case 'single':
            this.answerForm.answer = [];
            this.answerForm.answer.push(this.answer);
            break;
          case 'multiple':
            this.answerForm.answer = this.multipleAnswers;
            break;
        }
      } else if (this.optionValue && this.optionValue === this.QUESTION_SETTINGS_ALL) {

        this.$router.push({query: {question: priority}}).catch(() => {
        });
        switch (type) {
          case 'fill_in':
          case 'single':
            this.answer = '';
            this.answerForm.answer = [];
            this.answerForm.answer.push(answer);
            break;
          case 'multiple':
            this.answerForm.answer = answer;
            this.multipleAnswers = [];
            break;
        }
      }


      if (!this.$v.answerForm.$invalid) {

        await this.storeAnswer({...this.answerForm});
        this.answerForm.token = this.getAccessToken();

        await this.axios.post(this.$config.urls.candidateTesting.vote.url, this.answerForm)
            .then(response => {

              this.snotifySuccess('saveSuccessMsg', 1500);

              let data = response.data.data;

              if (!data.testing) {
                let timerInterval;

                Swal.fire({
                  title: this.getTranslation(data.message),
                  timer: 20000,
                  html: '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>',
                  footer: data.text ? this.getTranslation(data.text) : this.getTranslation('clickOK'),
                  showCancelButton: false,
                  showConfirmButton: true,
                  timerProgressBar: true,
                  onBeforeOpen: () => {
                    timerInterval = setInterval(() => {
                    }, 1000)
                  },
                  onClose: () => {
                    clearInterval(timerInterval)
                  }
                }).then((result) => {
                  this.resetTesting().then(() => {
                    if (data.testingId) {
                      this.$router.push({name: 'candidate.results', params: {id: data.testingId}}).catch(() => {
                      });
                    } else {
                      this.$router.push({name: 'auth.success'}).catch(() => {
                      });
                    }
                  });
                })
              } else {
                if (data.modal) {

                  this.$store.dispatch('candidate/setCurrentTesting', data.candidateTest);

                  let timerInterval;

                  let html = '';

                  if (data.testPoint === 0)
                    html = '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>';
                  else if (data.testPoint)
                    html = '<h4 class="text-center" >' + this.getTranslation('candidateTestPoint') + ' <span class="text--success text--bold" > ' + data.testPoint + '</span></h4>';

                  Swal.fire({
                    title: this.getTranslation(data.modal),
                    timer: 10000,
                    html: html,
                    footer: data.text ? this.getTranslation(data.text) : this.getTranslation('clickOK'),
                    showCancelButton: false,
                    showConfirmButton: true,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                      timerInterval = setInterval(() => {
                      }, 1000)
                    },
                    onClose: () => {
                      clearInterval(timerInterval)
                    }
                  }).then((result) => {
                    this.$router.replace({query: {question: '1'}});
                    this.$root.$emit('nextTest');
                  })
                }
              }

            }).catch(() => {
              this.snotifyError('errorAskAdmin', null, 5000);
            });
      }

    },

    getCurrentQuestion(id) {

      if (this.optionValue && this.optionValue === this.QUESTION_SETTINGS_ALL) {
        this.$scrollTo('#question-' + id);
      }

      let currentQuestion = this.questions.filter(item => item.priority === id);
      let currentQ = this.$store.getters['candidate/getCurrentTesting'].currentQuestion;
      this.resetFillables();

      if (currentQuestion.length === 1) {

        this.currentQuestion = currentQuestion[0];

        if (this.currentQuestion.test)
          this.$store.dispatch('candidate/setCurrentNPA', this.currentQuestion.test);

      } else if (currentQ) {

        currentQuestion = this.questions.filter(item => item.priority === currentQ);

        if (currentQuestion.length === 1) {

          this.currentQuestion = currentQuestion[0];

          if (this.currentQuestion.test)
            this.$store.dispatch('candidate/setCurrentNPA', this.currentQuestion.test);

          this.$router.push({query: {question: currentQ}}).catch(() => {
          });
        }
      } else {
        currentQuestion = this.questions.filter(item => item.priority === this.currentQuestionId);

        if (currentQuestion.length === 1) {

          this.currentQuestion = currentQuestion[0];

          if (this.currentQuestion.test)
            this.$store.dispatch('candidate/setCurrentNPA', this.currentQuestion.test);

          this.$router.push({query: {question: this.currentQuestionId}}).catch(() => {
          });
        }
      }

    },

    resetAnswerForm() {
      this.answerForm.questionId = '';
      this.answerForm.priority = '';
      this.answerForm.answer = [];
    },

    resetFillables() {
      this.answer = '';
      this.multipleAnswers = [];
    },

  },
  validations: {
    answerForm: {
      questionId: {
        required
      },
    }
  }
}
</script>

<style scoped>
.exam__question-section-title {
  max-width: 500px;
  margin-bottom: 5px;
  color: #0D3272;
  font-size: 15px;
  line-height: 24px;
  font-style: normal;
  font-weight: 700;
}

.maxHeight {
  max-height: 540px !important;
}

.pager-btn--disabled {
  opacity: .5 !important;
}

.exam__pager {
  position: fixed;
  top: 0;
  bottom: 66px;
  right: 0;
  z-index: 2;
  width: 51px;
  background-color: #F7FAFF;
  overflow: hidden;
}

.pager {
  margin-bottom: 50px !important;
  top: 0;
}

.exam__pager-expanded {
  width: 334px;
  overflow: visible;
}
</style>
